import Swal from 'sweetalert2'
import { ButtonNormal } from './button-normal'

type ButtonReinterpretProps = {
    onConfirm: () => void
    disabled?: boolean
    loading?: boolean
    isConsulting?: boolean
    hideWhenDisabled?: boolean
}

export const ButtonReinterpret = ({
    onConfirm,
    disabled = false,
    loading = false,
    isConsulting = false,
    hideWhenDisabled = true,
}: ButtonReinterpretProps) => {
    const askConfirm = async () => {
        const result = await Swal.fire({
            title: '¿Reinterpretar la tirada?',
            html: 'Esto vuelve a llamar a la API, consume tokens y puede demorar.<br/>Si solo querés ver el resultado, usá <b>Ver Respuesta</b>.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, reinterpretar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
            focusCancel: true,
        })
        if (result.isConfirmed) {
            onConfirm()
        }
    }

    return (
        <ButtonNormal
            caption={isConsulting ? 'Reinterpretando' : 'Reinterpretar'}
            onClick={() => {
                void askConfirm()
            }}
            disabled={disabled}
            loading={loading}
            hideWhenDisabled={hideWhenDisabled}
        />
    )
}
